import moment from "moment";
import "moment-timezone";
import React from "react";
import { formats } from "../../../variables/variables";

const TimeOffPeriods = ({ periods, remove, setAddMode, style = {} }) => (
  <div style={{ ...{ minWidth: 800 }, ...style }}>
    <h4>
      Time Off{" "}
      <small className="btn btn-link" onClick={() => setAddMode(true)}>
        add
      </small>
    </h4>
    {periods.length === 0 ? (
      <p>
        <span style={{ color: "#888" }}>
          none - the consultant follows their Regular Hours every day
        </span>
      </p>
    ) : (
      <>
        <table className="table table-condensed table-zebra" style={{ maxWidth: 700 }}>
          <thead>
            <tr>
              <th style={{ width: 200 }}>From</th>
              <th style={{ width: 200 }}>To</th>
              <th style={{ minWidth: 200 }}>Description</th>
            </tr>
          </thead>
          <tbody>
            {periods.map((period, index) => (
              <tr key={period.id}>
                <td>
                  <span
                    className="text-danger"
                    style={{ cursor: "pointer", marginRight: 10 }}
                    onClick={() => remove(index)}
                  >
                    <i className="far fa-times-circle"></i>
                  </span>
                  {moment(period.starts_on, formats.consistentDateFormat).format(
                    formats.shortDateYear
                  )}
                </td>
                <td>
                  {moment(period.ends_on, formats.consistentDateFormat).format(
                    formats.shortDateYear
                  )}
                </td>
                <td>{period.description || "-"}</td>
              </tr>
            ))}
          </tbody>
        </table>
        <p style={{ color: "#666", marginTop: -6 }}>
          <small>Regular Hours resume automatically after each period.</small>
        </p>
      </>
    )}
  </div>
);

export default TimeOffPeriods;
